<template>
  <div class="attachments-index-view">
    <h1>{{$t('titles.index')}}</h1>

    <file-upload-button :multiple="true" @change="refetchList" type="primary" />
    <link-button
      :to="{ name: 'new-attachment' }"
      icon="plus"
    >{{$t('actions.new')}}</link-button>

    <search-input class="uk-align-right" ref="search" v-model="searchQuery" />
    <data-grid
      :columns="gridColumns"
      :is-loading="isLoading"
      :page-info="attachments.pagination"
      :rows="attachments.entries"
      :sort-info="attachments.sort"
      :sortable="['name', 'updatedAt']"
      @sort="sortBy"
      class="uk-margin-medium"
      table-class="uk-table-middle"
      v-if="gridLoaded"
    >
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template slot="beforeHead">
        <th></th>
      </template>
      <template scope="props" slot="beforeRow">
        <td class="attachments-index-view__thumbnail-cell">
          <thumbnail
            :attachment="props.row"
            class="attachments-index-view__thumbnail"
          />
        </td>
      </template>
      <template scope="props" slot="name">
        <attachment-name :attachment="props.row" />
      </template>
      <template scope="props" slot="type">{{formatTypeName(props.row.type)}}</template>
      <template scope="props" slot="updatedAt">
        <timeago :auto-update="60" :since="props.row.updatedAt" />
      </template>
      <template scope="props" slot="actions">
        <data-grid-actions
          :edit-route="{ name: 'edit-attachment',
                                          params: { id: props.row.id } }"
          @remove="deleteRecordWhenConfirmed(props.row)"
        />
      </template>
    </data-grid>

    <div
      class="loader-container uk-container uk-margin-medium-top uk-text-center"
      v-else
    >
      <loader />
    </div>
  </div>
</template>

<script>
import camelCase from 'lodash/camelCase';
import AttachmentName from '@/components/AttachmentName';
import attachmentsQuery from '@/api/queries/attachments.graphql';
import deleteAttachmentMutation
  from '@/api/mutations/delete-attachment.graphql';
import FileUploadButton from '@/components/FileUploadButton';
import IndexView from '@/mixins/IndexView';
import TextPlaceholder from '@/components/TextPlaceholder';
import Thumbnail from '@/components/Thumbnail';

export default {
  name: 'attachments-index-view',
  mixins: [
    IndexView('attachments', {
      gridFields: ['name', 'type', 'updatedAt'],
      listQuery: attachmentsQuery,
      deleteMutation: deleteAttachmentMutation,
    }),
  ],
  components: {
    AttachmentName,
    FileUploadButton,
    TextPlaceholder,
    Thumbnail,
  },
  methods: {
    formatTypeName(type) {
      return this.$t(`attachmentTypes.${camelCase(type)}`);
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          new: 'Datei erstellen',
        },
        confirmations: {
          delete: 'Datei wirklich löschen?',
        },
        hints: {
          empty: 'Keine Dateien gefunden.',
        },
        titles: {
          index: 'Dateien',
        },
        toasts: {
          deleted: 'Datei gelöscht.',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments-index-view__thumbnail-cell {
  width: 100px;
}

.attachments-index-view__thumbnail {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// IndexView.vue?4792c1ba